import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';

import { APPLICATIONS, getApplicationAccessLink } from '~/components/ApplicationUrls';
import { CONTENT_ACCESS_TABS } from '../../config/constants';
import { SettingActionLoader } from '../../Loader';

import { DYNAMIC_REMOTES } from '~/config/app.constants';

export const SEARCH_ABLE_TAB = {
  [CONTENT_ACCESS_TABS.ASSET]: (
    <LoadRemote
      lazy={false}
      remote={DYNAMIC_REMOTES.GLOBAL_ASSET_SEARCH}
      loader={<SettingActionLoader />}
      searchRoute={getApplicationAccessLink(APPLICATIONS.GLOBAL_ASSET_SEARCH)}
    />
  ),
  default: (
    <LoadRemote
      lazy={false}
      remote={DYNAMIC_REMOTES.GLOBAL_SEARCH}
      loader={<SettingActionLoader />}
    />
  ),
};

export const IGNORE_SEARCH_TAB = [
  CONTENT_ACCESS_TABS.DIGITAL_SALES_ROOMS,
  CONTENT_ACCESS_TABS.CALLAI,
  CONTENT_ACCESS_TABS.ANALYTICS,
  CONTENT_ACCESS_TABS.MARKETPLACE,
  CONTENT_ACCESS_TABS.LEARNERS,
  CONTENT_ACCESS_TABS.NONE,
];
